export default "__VITE_ASSET__QZBYbn31__"